module.exports = __webpack_public_path__ + "static/media/attachment.3543348e.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/attachment.svg
// module id = 223
// module chunks = 0